import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { map, Observable } from "rxjs";
import { BeneficiaryManagementRequest, ClaimDetails, CreateDiariesRequest, GetClaimsByRREResponse, GetFTPsResponse, GetRREsResponse, RREItem, SimulateClaimSubmissionRequest } from "../models/qatools.model";
import { environment } from "../../environments/environment";
import { ClientSelectionService } from "../components/clients/client-selection.service";

@Injectable({
    providedIn: 'root'
})

export class QAToolsService {
    constructor(
        private http: HttpClient,
        private clientSelectionService: ClientSelectionService
    ) { }

    getFTPs(clientID: number, skip = 0, count = 20): Observable<GetFTPsResponse> {
        const headers = new HttpHeaders({
        });

        const params = new HttpParams()
            .set('clientID', clientID.toString())
            .set('skip', skip.toString())
            .set('count', count.toString());

        const url = `${environment.apiUrl}qa-tools/ftps`;
        return this.http.get<GetFTPsResponse>(url, { headers, params });
    }

    getRREs(rre?: string): Observable<GetRREsResponse> {
        let params = new HttpParams();

        if (rre?.trim()) {
            params = params.set('rre', rre.trim());
        }

        const url = `${environment.apiUrl}rre-management/rres`;

        return this.http.get<any>(url, { headers: this.getHeaders(), params }).pipe(
            map((response) => {
                const rreItems = this.extractRREItems(response);

                const totalCount =
                    response?.totalCount ??
                    response?.TotalCount ??
                    rreItems.length;

                return {
                    rres: rreItems,
                    totalCount: typeof totalCount === 'number' ? totalCount : rreItems.length,
                };
            })
        );
    }

    createDiaries(request: CreateDiariesRequest): Observable<{ success: boolean }> {
        const headers = new HttpHeaders({
        });

        const url = `${environment.apiUrl}qa-tools/create-diaries`;
        return this.http.post<{ success: boolean }>(url, request, { headers });
    }

    markBeneficiaries(request: BeneficiaryManagementRequest): Observable<string> {

        const url = `${environment.apiUrl}qa-tools/mark-beneficiary`;
        return this.http.post(url, request, { headers: this.getHeaders(), responseType: 'text' });
    }

    runNightlyJob(): Observable<string> {
        const url = `${environment.apiUrl}qa-tools/run-nightly-job`;
        return this.http.post(url, {}, { headers: this.getHeaders(), responseType: 'text' });
    
    }

    getClaimsByRRE(rre: string, sortBy = '', sortDir: 'asc' | 'desc' = 'asc', skip = 0, count = 20): Observable<GetClaimsByRREResponse> {
        let params = new HttpParams()
            .set('rre', rre)
            .set('sortBy', sortBy)
            .set('sortDir', sortDir)
            .set('skip', skip.toString())
            .set('count', count.toString());

        const url = `${environment.apiUrl}qa-tools/getClaimsByRRE`;
        return this.http.get<GetClaimsByRREResponse>(url, { headers: this.getHeaders(), params });
    }

    simulateClaimSubmission(request: SimulateClaimSubmissionRequest): Observable<string> {
        const url = `${environment.apiUrl}qa-tools/simulate-claim-submission`;
        return this.http.post(url, request, { headers: this.getHeaders(), responseType: 'text' });
    }
    
    private getHeaders(): HttpHeaders {
        const clientDbName = this.clientSelectionService.getSelectedClientDbName();

        return new HttpHeaders({
            ClientDBName: clientDbName,
        });
    }

    private extractRREItems(response: any): RREItem[] {
        const rawItems = Array.isArray(response?.rres)
            ? response.rres
            : Array.isArray(response?.RREList)
                ? response.RREList
                : [];

        return rawItems.map((item: any) => ({
            rre: item?.Rre,
            rreName: item?.RreName
        }));
    }
}